var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import React from 'react';
import classnames from 'classnames';
import NxTooltip from '../NxTooltip/NxTooltip';
import { propTypes, childPropTypes } from './types';
import './NxTreeView.scss';
var NxTreeView = function NxTreeView(props) {
    var onToggleCollapse = props.onToggleCollapse, isOpen = props.isOpen, disabled = props.disabled, children = props.children, triggerContent = props.triggerContent, triggerTooltip = props.triggerTooltip, className = props.className, id = props.id;
    var treeViewClasses = classnames('nx-tree-view', className, {
        'nx-tree-view--expanded': isOpen,
        'nx-tree-view--collapsed': !isOpen,
        'nx-tree-view--disabled': disabled,
        'nx-tree-view--empty': !React.Children.count(children)
    }), trigger = (React.createElement("div", { className: "nx-tree-view__trigger", onClick: onToggleCollapse || undefined },
        React.createElement("div", { className: "nx-tree-view__twisty" },
            React.createElement("span", { className: "nx-tree-view__twisty-icon" })),
        React.createElement("div", { className: "nx-tree-view__text" }, triggerContent))), triggerTooltipProps = typeof triggerTooltip === 'string' ? { title: triggerTooltip } : triggerTooltip;
    return (React.createElement("div", { className: treeViewClasses, id: id || undefined },
        triggerTooltipProps ? React.createElement(NxTooltip, __assign({}, triggerTooltipProps), trigger) : trigger,
        React.createElement("div", { className: "nx-tree-view__children" }, children)));
};
export var NxTreeViewChild = function NxTreeViewChild(props) {
    return (React.createElement("div", __assign({}, props, { className: classnames('nx-tree-view__child', props.className) })));
};
NxTreeViewChild.propTypes = childPropTypes;
NxTreeView.propTypes = propTypes;
export default NxTreeView;
//# sourceMappingURL=NxTreeView.js.map